import {QueryResult} from "@apollo/client/react/types/types";
import {FIND_ANNOUNCEMENTS_QUERY} from "../atoms/Queries";
import {findKeyByValue} from "../enums/FindKeyByValue";
import {useCoverage} from "./useCoverage";
import {OperationVariables, useQuery} from "@apollo/client";
import {Coverage} from "../enums/Coverage";
import {useMember} from "./useMember";
import {Announcements} from "../domain/Announcements";
import {EmployeeAssistanceProgramProvision} from "../enums/EmployeeAssistanceProgramProvision";

export function useAnnouncements(): QueryResult {
    const coverage = useCoverage();
    const { loading: memberLoading, data: memberData, error: memberError } = useMember();
    const hasNoEapProvision = memberData?.benefit?.employeeAssistanceProgramProvision === EmployeeAssistanceProgramProvision.NOT_INCLUDED

    const {
        loading: announcementsLoading,
        data: announcementsData,
        error: announcementsError,
        ...announcementsProps
    } = useQuery(FIND_ANNOUNCEMENTS_QUERY, {
        variables: {
            coverage: findKeyByValue(Coverage, coverage)
        } as OperationVariables
    })

    const findAnnouncements = announcementsData?.findAnnouncements;
    const filteredAnnouncements = hasNoEapProvision
        ? findAnnouncements?.filter((announcement: Announcements) => announcement.title !== 'Introducing EAP now provided by ComPsych')
        : findAnnouncements;

    return {
        ...announcementsProps,
        loading: announcementsLoading || memberLoading,
        data: filteredAnnouncements,
        error: announcementsError || memberError
    }
}
